"use client";

import { Suspense } from "react";
import Section from "../components/Section";
import { Accordion, AccordionItem, Grid2, Typography } from "@repo/ui";
import QueriesForm from "@/components/forms/QueriesForm";
import LoadMore from "@/components/LoadMore";
import { usePathname } from "next/navigation";

type CourseAgendaProps = {
  sectionInfo: PageSections;
  data: {
    courseAgenda?: {
      hasHtmlDescription?: boolean;
      description?: string;
      heading?: string;
      list?: {
        heading: string;
        description: string;
      }[];
    };
    heading: string;
    buttonText: string;
    buttonUrl: string;
    serviceId?: number;
  };
};

const CourseAgenda = ({ data, sectionInfo }: CourseAgendaProps) => {
  const { courseAgenda } = data;
  const pathname = usePathname();

  return (
    <Section
      className={`${sectionInfo.sectionClass} bg-gradient-to-b from-violet-50 to-white`}
      id={sectionInfo.sectionId}
      data-title={sectionInfo.name}
      title={data?.heading}
      actionLabel={data?.buttonText}
      path={data?.buttonUrl}
    >
      <Grid2 container spacing={5}>
        <Grid2 size={{ sm: 12, md: 8, lg: 8 }}>
          {courseAgenda?.hasHtmlDescription ? (
            <Accordion defaultValue={[0]} className="mb-5" openMultiple={false}>
              <AccordionItem title={courseAgenda?.heading} value={0}>
                <Typography>{courseAgenda?.description || ""}</Typography>
              </AccordionItem>
            </Accordion>
          ) : (
            <LoadMore
              wrapper={
                <Accordion
                  defaultValue={[0]}
                  className="mb-5"
                  openMultiple={false}
                />
              }
              items={courseAgenda?.list || []}
              render={(item, index) => (
                <AccordionItem
                  title={item?.heading}
                  value={index}
                  key={`course-agenda-${index}`}
                >
                  <Typography>{item?.description}</Typography>
                </AccordionItem>
              )}
            />
          )}
        </Grid2>
        <Grid2
          size={{ sm: 12, md: 4, lg: 4 }}
          id="request-for-group-training"
          className="sm:scroll-mt-[124px] scroll-mt-[88px]"
        >
          <Suspense>
            <QueriesForm
              color="primary"
              formHeading="Enquire us!"
              buttonLabel="Enquire now"
              serviceId={
                pathname.includes("/course/") ? data?.serviceId?.toString() : ""
              }
            />
          </Suspense>
        </Grid2>
      </Grid2>
    </Section>
  );
};

export default CourseAgenda;
